import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.99954 9H21.9995M10.4995 3L8.49954 9L12.4995 20.5L16.4995 9L14.4995 3M13.1141 20.2625L22.0727 9.51215C22.2246 9.32995 22.3005 9.23885 22.3295 9.13717C22.3551 9.04751 22.3551 8.95249 22.3295 8.86283C22.3005 8.76114 22.2246 8.67005 22.0727 8.48785L17.7394 3.28785C17.6512 3.18204 17.6072 3.12914 17.5531 3.09111C17.5052 3.05741 17.4518 3.03238 17.3953 3.01717C17.3314 3 17.2626 3 17.1248 3H7.87424C7.7365 3 7.66764 3 7.60382 3.01717C7.54728 3.03238 7.49385 3.05741 7.44596 3.09111C7.39192 3.12914 7.34783 3.18204 7.25966 3.28785L2.92633 8.48785C2.7745 8.67004 2.69858 8.76114 2.66957 8.86283C2.644 8.95249 2.644 9.04751 2.66957 9.13716C2.69858 9.23885 2.7745 9.32995 2.92633 9.51215L11.885 20.2625C12.096 20.5158 12.2015 20.6424 12.3279 20.6886C12.4387 20.7291 12.5603 20.7291 12.6712 20.6886C12.7975 20.6424 12.9031 20.5158 13.1141 20.2625Z",
      stroke: "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }